import { useAppSelector, useAppDispatch } from "@/services/hooks";
import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
import React, { useEffect, useCallback, useState } from "react";

import ReactBSAlert from "react-bootstrap-sweetalert";

import {
  getProductProperties,
  deleteProductProperties,
} from "@/services/productPropertiesServices/ProductPropertiesActions";
import NotificationAlertOptions from "@/layouts/Alerts";
import ReferrersDialog from "@/components/ReferrersDialog";
import { isDeleteRefusal, refusalMessage } from "@/services/deleteRefusal";

import ManageProductPropertiesView from "./ManageProductPropertiesView";

const ManageProductPropertiesContainer = () => {
  const dispatch = useAppDispatch();

  const productProperties = useAppSelector(
    (s) => s.productproperties.productproperties
  );
  const permission = useCurrentPermission();

  const [alertNode, setAlertNode] = useState<React.ReactNode>(null);

  useEffect(() => {
    dispatch(getProductProperties());
  }, [dispatch]);

  const hideAlert = useCallback(() => setAlertNode(null), []);

  const openDeleteConfirm = useCallback(
    (id: string) => {
      setAlertNode(
        // @ts-expect-error react-bootstrap-sweetalert prop-types (customIcon/btnSize)
        <ReactBSAlert
          custom
          style={{ display: "block", marginTop: "-100px" }}
          title="Would you like to remove the properties from this product?"
          customIcon={
            <div
              className="swal2-icon swal2-question swal2-animate-question-icon"
              style={{ display: "flex" }}
            >
              <span className="swal2-icon-text">?</span>
            </div>
          }
          onConfirm={async () => {
            hideAlert();
            try {
              // SCRUM-840: only claim success once the delete resolves; the
              // central hub surfaces the error on failure.
              await dispatch(deleteProductProperties(id)).unwrap();
              NotificationAlertOptions(
                "success",
                "Properties deleted from product successfully"
              );
            } catch (err) {
              // SCRUM-2353: refused while product pages still show the row —
              // the list (SCRUM-2352); other failures go to the central hub.
              if (isDeleteRefusal(err)) {
                setAlertNode(
                  <ReferrersDialog
                    message={refusalMessage(err)}
                    referrers={err.referrers}
                    onClose={hideAlert}
                  />
                );
              }
            }
          }}
          onCancel={hideAlert}
          confirmBtnBsStyle="default"
          confirmBtnText="Ok"
          btnSize=""
        >
          You can add properties to this product in Set Initial Properties section
        </ReactBSAlert>
      );
    },
    [dispatch, hideAlert]
  );
  return (
    <ManageProductPropertiesView
      data={productProperties || []}
      permission={permission}
      alertNode={alertNode}
      onRequestDelete={openDeleteConfirm}
    />
  );
};

export default ManageProductPropertiesContainer;
